"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7728],{

/***/ 87607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var utils_i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87161);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19521);
/* harmony import */ var styles_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64014);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-grow: 1 !important;\n  width: 100%;\n  min-height: 36px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  ",
        " {\n    border-bottom: 1px solid var(--border);\n    background-color: var(--body-background-medium);\n    padding-right: 1rem;\n    padding-left: 1rem;\n  }\n\n  ul {\n    font-size: 0.875rem;\n    margin-bottom: 0;\n    padding: 0;\n    width: 100%;\n\n    li {\n      display: inline;\n\n      ",
        " {\n        display: inline-block;\n      }\n\n      &:after {\n        display: inline;\n        margin: 0 6px;\n        color: var(--secondary-base);\n      }\n\n      &:not(:last-of-type):after {\n        content: '/';\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var Breadcrumb = function(param) {
    var breadcrumb = param.breadcrumb;
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)(), locale = ref.locale, asPath = ref.asPath;
    var dictionary = utils_i18n__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[locale || "en-US"].dictionary;
    if (!breadcrumb.length) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledBreadcrumb, {
        "data-bi-name": "breadcrumb",
        itemType: "http://schema.org/BreadcrumbList",
        role: "navigation",
        "aria-label": "Breadcrumb",
        itemScope: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("ul", {
            id: "page-breadcrumbs",
            className: "breadcrumbs",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("li", {
                    itemProp: "itemListElement",
                    itemScope: true,
                    itemType: "http://schema.org/ListItem",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                            href: "/",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                itemProp: "item",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                    itemProp: "name",
                                    children: dictionary.breadcrumbHomeName
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                            itemProp: "position",
                            content: "1"
                        })
                    ]
                }),
                breadcrumb.filter(Boolean).map(function(item, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("li", {
                        itemProp: "itemListElement",
                        itemType: "http://schema.org/ListItem",
                        itemScope: true,
                        children: [
                            item.path === asPath ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                itemProp: "name",
                                children: item.label
                            }) : // <Link href={`${PATH_LEARN_NO_SLASH}${item.path}`}>
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                href: "/".concat(item.path),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                    itemProp: "item",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                        itemProp: "name",
                                        children: item.label
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                                itemProp: "position",
                                content: (index + 2).toString()
                            })
                        ]
                    }, "file-".concat(item.id));
                })
            ]
        })
    });
};
var StyledBreadcrumb = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].nav.withConfig */ .ZP.nav.withConfig({
    componentId: "sc-d68c8646-0"
})(_templateObject(), styles_styles__WEBPACK_IMPORTED_MODULE_6__/* .mqUntil.mobile */ .x1.mobile, styles_styles__WEBPACK_IMPORTED_MODULE_6__/* .mqFrom.mobile */ .wO.mobile);
/* harmony default export */ __webpack_exports__["Z"] = (Breadcrumb);


/***/ }),

/***/ 60611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export HeadlineBanner */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: var(--primary-base);\n  color: var(--text-invert);\n  margin-bottom: 3rem;\n\n  .headline {\n    padding-top: 3rem;\n    padding-bottom: 3rem;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var HeadlineBanner = function(param) {
    var title = param.title, subtitle = param.subtitle, _wide = param.wide, wide = _wide === void 0 ? false : _wide, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledHeadlineBanner, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, "inner ".concat(wide ? "" : "small-", "outer-padding")),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "headline",
                children: [
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                        children: title
                    }),
                    subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                        children: subtitle
                    })
                ]
            })
        })
    });
};
var StyledHeadlineBanner = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-bc859481-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (HeadlineBanner);


/***/ }),

/***/ 18707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _context_global_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72265);



var Settings = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context_global_context__WEBPACK_IMPORTED_MODULE_2__/* .GlobalContext */ .k), theme = ref.theme, setTheme = ref.setTheme;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(theme === "light" ? false : true), isChecked = ref1[0], setIsChecked = ref1[1];
    var handleChange = function() {
        return setIsChecked(!isChecked);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var theme = localStorage.getItem("continia.theme");
        if (theme) {
            setIsChecked(theme === "dark");
            setTheme(theme === "dark" ? "dark" : "light");
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        localStorage.setItem("continia.theme", isChecked ? "dark" : "light");
        setTheme(isChecked ? "dark" : "light");
    }, [
        isChecked,
        setTheme
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex justify-end align-center items-center ",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "h-20 flex justify-end align-center items-center mr-2"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Settings);


/***/ }),

/***/ 57343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports VideoItem, StyledVideoItem */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: var(--body-background);\n  border: 1px solid var(--border-white-high-contrast);\n  border-color: transparent;\n  border-top-left-radius: 0.5rem;\n  border-top-right-radius: 0.5rem;\n  box-shadow: 0 1.6px 3.6px 0 var(--box-shadow-medium), 0 0.3px 0.9px 0 var(--box-shadow-light);\n  color: var(--text);\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  justify-content: flex-start;\n  outline-color: var(--text);\n\n  .img {\n    width: 100%;\n    /* padding-top: 56.25%; */\n    position: relative;\n    border-top-left-radius: 0.5rem;\n    border-top-right-radius: 0.5rem;\n\n    img {\n      width: 100%;\n      border-top-left-radius: 0.5rem;\n      border-top-right-radius: 0.5rem;\n    }\n  }\n\n  .details {\n    border: 1px solid var(--border-white-high-contrast);\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    justify-content: flex-start;\n    padding: 1rem;\n    width: 100%;\n\n    .h3 {\n      font-size: 1rem;\n      font-weight: 600;\n      line-height: 1.25;\n      text-align: left;\n      margin: 0.3rem 0 0.3rem 0;\n    }\n\n    .published {\n      font-size: 0.875rem;\n      font-weight: 600;\n    }\n\n    .description {\n      color: var(--text-subtle);\n      font-size: 0.875rem;\n      line-height: 1.5;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* eslint-disable @next/next/no-img-element */ 
// import Image from 'next/image';


var VideoItem = function(param) {
    var video = param.video;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var currentPath = router.asPath.split("?")[0];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledVideoItem, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("article", {
            children: [
                video.imageUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "img",
                    children: video.externalLink ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                        href: video.externalLink,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: "h3",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                            src: video.imageUrl,
                            alt: video.title
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                        href: "".concat(currentPath, "?id=").concat(video.id),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                            className: "h3",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                src: video.imageUrl,
                                alt: video.title
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "details",
                    children: [
                        video.externalLink ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                            href: video.externalLink,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            className: "h3",
                            dangerouslySetInnerHTML: {
                                __html: video.title
                            }
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                            href: "".concat(currentPath, "?id=").concat(video.id),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                className: "h3",
                                dangerouslySetInnerHTML: {
                                    __html: video.title
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "published",
                            children: new Date(video.published).toDateString()
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "description",
                            children: video.description
                        })
                    ]
                })
            ]
        })
    });
};
var StyledVideoItem = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].article.withConfig */ .ZP.article.withConfig({
    componentId: "sc-2223abfe-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["ZP"] = (VideoItem);


/***/ }),

/***/ 55026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  position: relative;\n  padding-bottom: ",
        "%;\n  height: 0;\n  overflow: hidden;\n  margin: 1.5rem 0;\n\n  iframe,\n  object,\n  embed {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var YoutubeEmbed = function(param) {
    var id = param.id, _width = param.width, width = _width === void 0 ? 800 : _width, _height = param.height, height = _height === void 0 ? 450 : _height;
    var dimensionPadding = height / width * 100;
    var embedCode = '<iframe loading="lazy" width="'.concat(width, '" height="').concat(height, '" src="//www.youtube-nocookie.com/embed/').concat(id.split("&")[0], '?autoplay=0&rel=0&modestbranding=1" frameborder="0" allowfullscreen></iframe>');
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(EmbedStyled, {
        padding: dimensionPadding,
        dangerouslySetInnerHTML: {
            __html: embedCode
        }
    });
};
var EmbedStyled = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-cb950233-0"
})(_templateObject(), function(props) {
    return props.padding;
});
/* harmony default export */ __webpack_exports__["Z"] = (YoutubeEmbed);


/***/ }),

/***/ 13302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ master_layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/breadcrumb.tsx
var components_breadcrumb = __webpack_require__(87607);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/library/header.tsx + 3 modules
var header = __webpack_require__(60257);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(57632);
// EXTERNAL MODULE: ./utils/i18n.ts + 3 modules
var i18n = __webpack_require__(87161);
// EXTERNAL MODULE: ./components/tailwind-m/settings.tsx
var settings = __webpack_require__(18707);
;// CONCATENATED MODULE: ./components/tailwind-m/footer.tsx







var LandingSignin = function() {
    var locale = (0,router.useRouter)().locale;
    var footerlinks = i18n/* default */.Z[locale || "en-US"].footerlinks;
    var keys = (0,react.useMemo)(function() {
        return footerlinks.map(function() {
            return (0,v4/* default */.Z)();
        });
    }, [
        footerlinks
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        className: "bg-footer w-full h-nav flex justify-center border-t border-border",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-full flex items-center justify-between outer-padding",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(settings/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "flex flex-wrap gap-x-10 items-center",
                    children: footerlinks.map(function(link, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: link.href,
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-sm text-textRegular flex items-center font-normal",
                                        children: link.name
                                    })
                                })
                            })
                        }, keys[index]);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var footer = (LandingSignin);

;// CONCATENATED MODULE: ./layouts/master-layout.tsx

/* eslint-disable @typescript-eslint/no-empty-function */ 







var Layout = function(param) {
    var children = param.children, breadcrumb = param.breadcrumb, title = param.title, description = param.description, mainClassName = param.mainClassName;
    var isPreview = (0,router.useRouter)().isPreview;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        httpEquiv: "X-UA-Compatible",
                        content: "IE=Edge"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=no, shrink-to-fit=no"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "last-build",
                        content: new Date().toISOString()
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* default */.Z, {}),
            console.log("breadcrumb", breadcrumb),
            breadcrumb.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "breadcrumb outer-padding",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_breadcrumb/* default */.Z, {
                    breadcrumb: breadcrumb
                })
            }),
            isPreview && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "preview-warning",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "You are in preview mode"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/api/editor/clear-preview-data",
                        prefetch: false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: "Clear Cookies"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                id: "main-content",
                className: classnames_default()(mainClassName),
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer, {})
        ]
    });
};
/* harmony default export */ var master_layout = (Layout);


/***/ }),

/***/ 52463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_useClickAway; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-use/esm/misc/util.js
var noop = function () { };
function on(obj) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (obj && obj.addEventListener) {
        obj.addEventListener.apply(obj, args);
    }
}
function off(obj) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (obj && obj.removeEventListener) {
        obj.removeEventListener.apply(obj, args);
    }
}
var isBrowser = typeof window !== 'undefined';
var isNavigator = typeof navigator !== 'undefined';

;// CONCATENATED MODULE: ./node_modules/react-use/esm/useClickAway.js


var defaultEvents = ['mousedown', 'touchstart'];
var useClickAway = function (ref, onClickAway, events) {
    if (events === void 0) { events = defaultEvents; }
    var savedCallback = (0,react.useRef)(onClickAway);
    (0,react.useEffect)(function () {
        savedCallback.current = onClickAway;
    }, [onClickAway]);
    (0,react.useEffect)(function () {
        var handler = function (event) {
            var el = ref.current;
            el && !el.contains(event.target) && savedCallback.current(event);
        };
        for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
            var eventName = events_1[_i];
            on(document, eventName, handler);
        }
        return function () {
            for (var _i = 0, events_2 = events; _i < events_2.length; _i++) {
                var eventName = events_2[_i];
                off(document, eventName, handler);
            }
        };
    }, [events, ref]);
};
/* harmony default export */ var esm_useClickAway = (useClickAway);


/***/ })

}]);